import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { RouterProvider, Route } from 'react-router5';
import * as Actions from '../common/services/actions';
import configureStore from '../common/services/store';
import router from '../common/routes/router';
import TWICLCompaniesListing from '../listings/TWICLCompaniesListing/TWICLCompaniesListing';


let store;

function TWICLCompaniesApp() {

	return (
		<Provider store={store}>
			<RouterProvider router={router}>
				<TWICLCompaniesListing />
			</RouterProvider>
		</Provider>
	);
}

export function renderTWICLCompanies(id, mg, auth, micrositeRender) {
	if (!store) {
		store = configureStore(router);
	}
	store.dispatch(Actions.initialiseSettings('TWICLCompaniesAppId', mg, auth, micrositeRender));
	router.start(() => {
		ReactDOM.render(<TWICLCompaniesApp />, document.getElementById(id));
	});
}
